import { format as dateFnsFormat } from 'date-fns'
import type { User } from '@/types/entities'

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

export function formatDate(date: string | Date): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateFnsFormat(dateObj, 'MMM d, yyyy')
}

export function formatDateTime(date: string | Date): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateFnsFormat(dateObj, 'MMM d, yyyy h:mm a')
}

export function formatUserName(user: User): string {
  if (!user) return 'Unknown User'
  return user.artisticName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'User'
}

export function getInitials(user: User): string {
  if (!user) return 'U'
  const firstInitial = user.firstName?.[0] || user.email?.[0] || 'U'
  const lastInitial = user.lastName?.[0] || user.email?.[1] || ''
  return `${firstInitial}${lastInitial}`.toUpperCase()
}

export function truncate(text: string, length: number): string {
  if (text.length <= length) return text
  return text.slice(0, length) + '...'
}

